import api, {
  PaginateRequest, PaginateResponse, ResponseCallback
} from '../services/api.service'
import alertService from '../services/alert.service'
import routeUtil from '../utils/route.util'
import { InventoryData } from './inventory.api'
import { PalletData } from './pallet.api'
import { Markup as LabelMarkup } from '../views/LabelBuilder/LabelBuilder.slice'

export interface CaseData {
  id: number
  inventoryId: number
  palletId?: number
  quantity: number
  number: number
  position: number
  code: string
  isBare: boolean
  inventory?: InventoryData
  pallet?: PalletData
}

export interface CaseAssignRequest {
  palletCode?: string
  cases?: string[]
  latitude?: number
  longitude?: number
}

type CasePaginateBareResponse = PaginateResponse<CaseData[]>

export interface CaseTransferRequest {
  sourcePallet?: number
  targetPallet?: number
  cases?: number[],
  isMixed: boolean
}

export interface CaseConsumeRequest {
  workOrder?: number
}

interface CaseConsumeReqsponse {
  consume: boolean
}

export interface CaseConsumeQuantityRequest {
  workOrder?: number
  quantity?: number
}

interface CaseConsumeQuantityReqsponse extends CaseConsumeReqsponse {}

export interface CaseRollbackConsumeRequest {
  consumed?: number
}

interface CaseRollbackConsumeReqsponse {
  rollback: boolean
}

export interface CaseTransferQuantityRequest {
  sourceCase?: number
  targetCase?: number
  quantity?: number
}

const routes = {
  readByCode: '/cases/code/{code}',
  print: '/cases/{id}/print',
  assign: '/cases/assign',
  paginateBare: '/cases/bare/paginate',
  transfer: '/cases/transfer',
  consume: '/cases/{id}/consume',
  consumeQuantity: '/cases/{id}/consumeQuantity',
  rollbackConsume: '/cases/{id}/rollbackConsume',
  transferQuantity: '/cases/quantity/transfer'
}

export default {
  readByCode (code: string, callback: ResponseCallback<CaseData>) {
    const url = routeUtil.replaceParams(routes.readByCode, { code })
    api.get(url, {}, callback)
  },

  print (id: number, callback: ResponseCallback<LabelMarkup[]>) {
    alertService.info('Case generating...')
    const url = routeUtil.replaceParams(routes.print, { id })
    api.get(url, {}, callback)
  },

  assign (payload: CaseAssignRequest, callback: ResponseCallback<CaseData[]>) {
    api.post(routes.assign, payload, callback)
  },

  paginateBare (
    params: PaginateRequest,
    callback: ResponseCallback<CasePaginateBareResponse>
  ) {
    api.get(routes.paginateBare, params, callback)
  },

  transfer (
    payload: CaseTransferRequest,
    callback: ResponseCallback<PalletData>
  ) {
    api.post(routes.transfer, payload, callback)
  },

  consume (
    id: number,
    payload: CaseConsumeRequest,
    callback: ResponseCallback<CaseConsumeReqsponse>
  ) {
    const url = routeUtil.replaceParams(routes.consume, { id })
    api.post(url, payload, callback)
  },

  consumeQuantity (
    id: number,
    payload: CaseConsumeQuantityRequest,
    callback: ResponseCallback<CaseConsumeQuantityReqsponse>
  ) {
    const url = routeUtil.replaceParams(routes.consumeQuantity, { id })
    api.post(url, payload, callback)
  },

  rollbackConsume (
    id: number,
    payload: CaseRollbackConsumeRequest,
    callback: ResponseCallback<CaseRollbackConsumeReqsponse>
  ) {
    const url = routeUtil.replaceParams(routes.rollbackConsume, { id })
    api.post(url, payload, callback)
  },

  transferQuantity (
    payload: CaseTransferQuantityRequest,
    callback: ResponseCallback<CaseData>
  ) {
    api.post(routes.transferQuantity, payload, callback)
  }
}
